import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiFileText, FiRepeat, FiTool } from 'react-icons/fi';
import Card from '../../../components/Card';
import { useLanguage } from '../../../i18n/LanguageContext';
import './tools.css';

const ToolsPage = () => {
  const { t } = useLanguage();
  const text = t.toolsPage;
  const tools = [
    {
      key: 'pdf-repair',
      title: text.pdfRepair.title,
      description: text.pdfRepair.subtitle,
      path: '/tools/pdf-repair',
      icon: <FiFileText aria-hidden="true" />,
    },
    {
      key: 'subject-compare',
      title: text.subjectCompare.title,
      description: text.subjectCompare.subtitle,
      path: '/tools/subject-compare',
      icon: <FiRepeat aria-hidden="true" />,
    },
  ];

  return (
    <div className="quizify-tools-page">
      <div className="quizify-tools-header">
        <div className="quizify-tools-title-row">
          <span className="quizify-tools-title-icon">
            <FiTool aria-hidden="true" />
          </span>
          <div>
            <h1>{text.title}</h1>
            <p>{text.subtitle}</p>
          </div>
        </div>
      </div>

      <Row className="g-3">
        {tools.map((tool) => (
          <Col key={tool.key} md={6}>
            <Card className="quizify-tool-card h-100">
              <Card.Body>
                <div className="quizify-tool-card-icon">{tool.icon}</div>
                <div className="quizify-tool-card-content">
                  <h2>{tool.title}</h2>
                  <p>{tool.description}</p>
                </div>
                <Button as={Link} to={tool.path} variant="primary" className="quizify-tool-open-btn">
                  <span>{text.openTool}</span>
                  <FiArrowRight aria-hidden="true" />
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ToolsPage;
